import {
  Grid,
  Button,
  Paper,
  Typography,
  List,
  ListItem,
  Avatar,
  ListItemText,
  Divider,
  TextField,
  Backdrop,
  CircularProgress,
  ListItemSecondaryAction,
  IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { useTranslation } from 'react-i18next';
import 'react-dropzone-uploader/dist/styles.css';
import axios from 'src/utils/customAxios';
import { getUser } from 'src/utils/Common';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Fab from '@material-ui/core/Fab';
import SendIcon from '@material-ui/icons/Send';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { green, pink } from '@material-ui/core/colors';
import moment from 'moment';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CallEndIcon from '@material-ui/icons/CallEnd';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    width: 500,
    height: 450
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  paper: {
    width: "80vw",
    height: "80vh",
    maxWidth: "500px",
    maxHeight: "700px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative"
  },
  paper2: {
    width: "80vw",
    maxWidth: "500px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative"
  },
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  messagesBody: {
    width: "calc( 100% - 20px )",
    margin: 10,
    overflowY: "scroll",
    height: "calc( 100% - 80px )"
  },
  table: {
    minWidth: 650,
  },
  chatSection: {
    width: '100%',
    height: '100%'
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    height: '90%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column-reverse',
    backgroundColor: '#efeae2',
    backgroundImage: 'url(/images/wpRealBack.png)',
    backgroundSize: 'contain'
  },
  sendMessage: {
    textAlign: 'left',
    backgroundColor: '#d9fdd3',
    padding: '1%',
    width: '100%',
    maxWidth: 'fit-content',
    minWidth: '20rm',
    borderRadius: '0.6rem',
    alignItems: "center"
  },
  receivedMessage: {
    textAlign: 'left',
    backgroundColor: '#FFFFFF',
    padding: '1%',
    width: '100%',
    maxWidth: 'fit-content',
    minWidth: '20rm',
    borderRadius: '0.6rem',
    alignItems: "center"
  },
  green: {
    color: '#fff',
    backgroundColor: green[500],
  },
  denemeTextScreen: {
    boxSizing: 'border-box',
    flex: '1 1 auto',
    minWidth: '0',
    minHeight: '20px',
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '20px',
    outline: 'none',
    willChange: 'width',
    padding: '9px 11px',
    margin: '5px 10px',
    backgroundColor: '#fff',
    border: '1px solid #fff',
    borderRadius: '8px'
  }
}));

function OmniChannel({ }) {

  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [TextSend, setTextSend] = useState('')
  const [WhatsAppMessageList, setWhatsAppMessageList] = useState([])
  const [Loading, setLoading] = useState(false);
  const [UserChannelList, setUserChannelList] = useState([])
  const [UnassigendUserChannelList, setUnassigendUserChannelList] = useState([])
  const [ClientAdress, setClientAdress] = useState()
  const SessionUser = getUser();
  const [OpenCasesAccordionOpen, setOpenCasesAccordionOpen] = useState(false)
  const [CasesAccordionOpen, setCasesAccordionOpen] = useState(false)
  const [SelectedSocialChannelConversationId, setSelectedSocialChannelConversationId] = useState(0)

  useEffect(() => {
    getWhatsAppUserList(1)
    getWhatsAppUnasignedUserList(1)
  }, [])

  async function getWhatsAppUserList(channelId) {
    setLoading(true)
    axios.get(`/OmniChannel/GetSocialChannelUserList/${channelId}/${SessionUser.TechnicianId}`)
      .then(response => {
        setUserChannelList(response.data)
        setCasesAccordionOpen(response?.data?.length > 0 ? true : false)
        setLoading(false)
      }).catch(error => { setLoading(false) })
  }

  async function getWhatsAppUnasignedUserList(channelId) {
    setLoading(true)
    axios.get(`/OmniChannel/GetSocialChannelUnassignedUserList/${channelId}/${SessionUser.TechnicianId}`)
      .then(response => {
        setUnassigendUserChannelList(response.data)
        setOpenCasesAccordionOpen(response?.data?.length > 0 ? true : false)
        setLoading(false)
      }).catch(error => { setLoading(false) })
  }

  function sendWhatsAppMessage() {
    if (ClientAdress === null || ClientAdress === undefined) {
      return
    }

    const data = {
      SendAdress: ClientAdress,
      SendMessage: TextSend,
      EmployeeId: SessionUser.TechnicianId
    }
    setTextSend('')
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true)
    axios
      .post('/OmniChannel/SendWhatsAppSms', data, config)
      .then(response => {
        getWhatsAppMessages(data.SendAdress, SelectedSocialChannelConversationId)
        setLoading(false)
      })
      .catch(error => { setLoading(false) });
  }

  function getWhatsAppMessages(clientAdress, SocialChannelConversationId) {
    setLoading(true)
    axios.get(`/OmniChannel/GetSocialChannelMessages/${clientAdress}/${1}`)
      .then(response => {
        setWhatsAppMessageList(response.data)
        setClientAdress(clientAdress)
        setSelectedSocialChannelConversationId(SocialChannelConversationId)
        setLoading(false)
      }).catch(error => { setLoading(false) })
  }

  function pickOpenCase(openCase) {
    const data = {
      SocialChannelConversationId: openCase.SocialChannelConversationId,
      EmployeeId: SessionUser.TechnicianId,
      StatusId: 2
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true)
    axios
      .post('/OmniChannel/UpdateSocialChannelConversation', data, config)
      .then(response => {
        getWhatsAppUserList(1)
        getWhatsAppUnasignedUserList(1)
        setLoading(false)
      })
      .catch(error => { setLoading(false) });
  }

  function closeCall() {
    if (SelectedSocialChannelConversationId < 1) {
      return
    }

    const data = {
      SocialChannelConversationId: SelectedSocialChannelConversationId,
      EmployeeId: SessionUser.TechnicianId,
      StatusId: 3
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true)
    axios
      .post('/OmniChannel/UpdateSocialChannelConversation', data, config)
      .then(response => {
        setSelectedSocialChannelConversationId(0)
        getWhatsAppUserList(1)
        getWhatsAppUnasignedUserList(1)
        setLoading(false)
      })
      .catch(error => { setLoading(false) });
  }

  return (
    <div style={{ height: '100%' }}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container component={Paper} className={classes.chatSection}>
        <Grid item xs={3} className={classes.borderRight500}>
          <Grid item xs={12} style={{ padding: '10px' }}>
            <TextField id="outlined-basic-email" label={t('lblSearch')} variant="outlined" fullWidth />
          </Grid>
          <List>
            <Divider />
            <Accordion expanded={OpenCasesAccordionOpen} onChange={() => setOpenCasesAccordionOpen(!OpenCasesAccordionOpen)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{t('lblOpenCases')}</Typography>
                <Chip label={UnassigendUserChannelList.length} style={{ marginLeft: "1vh", marginTop: "-0.6vh", backgroundColor: "#25D366", color: "white" }} />
              </AccordionSummary>
              <AccordionDetails>
                <List style={{ width: '100%' }}>
                  {
                    UnassigendUserChannelList?.map((item, index) => (
                      <>
                        <Divider />
                        <ListItem key={index} button={true}
                        // onClick={() => { getWhatsAppMessages(item.UserAdress)}}
                        >
                          <ListItemIcon>
                            <Avatar style={{ backgroundColor: '#128C7E' }}>
                              <WhatsAppIcon />
                            </Avatar>
                          </ListItemIcon>
                          <br></br>
                          <ListItemText style={{ marginLeft: "10px" }} primary={item.UserAdress}></ListItemText>
                          <ListItemSecondaryAction>
                            <Button
                              variant="contained"
                              style={{ color: "white", backgroundColor: "#34b7f1" }}
                              size="small"
                              className={classes.button}
                              onClick={() => pickOpenCase(item)}
                              startIcon={<AddCircleIcon />}
                            >
                              Pick
                            </Button>
                          </ListItemSecondaryAction>
                        </ListItem>
                      </>
                    ))
                  }
                </List>

              </AccordionDetails>
            </Accordion>
            <Accordion expanded={CasesAccordionOpen} onChange={() => setCasesAccordionOpen(!CasesAccordionOpen)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{t('lblCases')}</Typography>
                <Chip label={UserChannelList?.length} style={{ marginLeft: "1vh", marginTop: "-0.6vh", backgroundColor: "#128C7E", color: "white" }} />
              </AccordionSummary>
              <AccordionDetails>
                <List style={{ width: '100%' }}>
                  {
                    UserChannelList?.map((item, index) => (
                      <>
                        <Divider />
                        <ListItem key={index} button={true} onClick={() => { getWhatsAppMessages(item.UserAdress, item.SocialChannelConversationId) }}>
                          <ListItemIcon>
                            <Avatar style={{ backgroundColor: '#25D366' }}>
                              <WhatsAppIcon />
                            </Avatar>
                          </ListItemIcon>
                          <br></br>
                          <ListItemText style={{ marginLeft: "10px" }} primary={item.UserAdress}></ListItemText>
                        </ListItem>
                      </>
                    ))
                  }
                </List>

              </AccordionDetails>
            </Accordion>
          </List>
        </Grid>

        <Grid item xs={9} style={{ maxHeight: '100%' }}>
          <List className={classes.messageArea}>
            <Grid container>
              {WhatsAppMessageList?.map((item, index) => (
                item.From == "+14155238886" ?
                  <Grid container
                    direction="row-reverse"
                    justifyContent="flex-start"
                    alignItems="center" >
                    <Grid item xs={12} style={{ marginRight: '25px', marginTop: '5px', marginBottom: '5px' }} container justifyContent="flex-end">
                      <ListItem key={index} className={classes.sendMessage}>
                        <Grid container>
                          <Grid item xs={12}>
                            <ListItemText
                              disableTypography
                              primary={<Typography type="body2" style={{ color: '#455551', fontWeight: 'bold' }}> {item.Message} </Typography>}
                            />
                            <ListItemText
                              disableTypography
                              primary={<Typography style={{ color: '#667781' }}> {moment(item.CreateDate).format('HH:mm')} </Typography>}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  </Grid>
                  :
                  <Grid container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center">
                    <Grid item xs={12} style={{ marginLeft: '25px', marginTop: '5px', marginBottom: '5px' }}>
                      <ListItem key={index} className={classes.receivedMessage}>
                        <Grid container>
                          <Grid item xs={12}>
                            <ListItemText
                              disableTypography
                              primary={<Typography type="body2" style={{ color: '#455551', fontWeight: 'bold' }}> {item.Message} </Typography>}
                            />
                            <ListItemText
                              disableTypography
                              primary={<Typography style={{ color: '#667781' }}> {moment(item.CreateDate).format('HH:mm')} </Typography>}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  </Grid>
              ))}
            </Grid>
          </List>
          <Divider />
          <Grid container style={{ backgroundColor: '#f0f2f5', height: '10%' }}>
            <Grid xs={1} align="center">
              <IconButton color="primary" component="span"
                disabled = {!(SelectedSocialChannelConversationId > 0)}
                onClick={() => closeCall()}>
                <CallEndIcon />
              </IconButton>
            </Grid>
            <Grid item xs={10}>
              <TextField className={classes.denemeTextScreen}
                value={TextSend}
                onChange={event => setTextSend(event.target.value)}
                fullWidth />
              {/* <div tabindex="-1" className={classes.denemeTextScreen}>
              </div> */}
            </Grid>
            <Grid xs={1} align="right">
              <Fab
                style={{ backgroundColor: '#128C7E' }}
                color="secondary"
                onClick={() => sendWhatsAppMessage()}
                aria-label="add">
                <SendIcon />
              </Fab>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

OmniChannel.propTypes = {
  className: PropTypes.string
};

export default OmniChannel
